import Form from "./Form";
import usePersonalInformation from "./hooks/usePersonalInformation";

export const PersonalInformation: React.FC = () => {
  const { ...props } = usePersonalInformation();

  return <Form {...props} />;
};
export default PersonalInformation;
